import axios from "axios";
import { errorResponse } from "src/store/common";
import Cookies from 'js-cookie';
import { alertMessages } from "src/constants";
import { getAccessTokenCookie } from "./AuthProvider";

export const removeUser = (setUser: any, setUserTokens:any)=>{
    localStorage.removeItem('user');
    localStorage.removeItem('authExpires')
    Cookies.remove('accessToken');
    Cookies.remove('refreshToken');
    Cookies.remove('authCode');
    Cookies.remove('expiresIn');
    setUserTokens(null)
    setUser(null);
}

export const refreshAuth = async(addAlert: any, setUser: any, setUserTokens:any) =>{
    const refreshTok = getAccessTokenCookie('refreshToken');
    const aCode = getAccessTokenCookie('authCode');
    try {
        return (
            await new Promise(function(resolve,reject) {
                const url = process.env.REACT_APP_REQUEST_URL?.split('authenticate/')[0];
                axios.get(`${url}refresh/${refreshTok}/${aCode}`)
                .then(async function (response: any) {
                    return resolve(response.data);
                })
                .catch(function (error) {
                    console.log('error', error);
                    removeUser(setUser, setUserTokens)
                    errorResponse(error, addAlert, alertMessages.loginError);
                    return reject(new Error(error));
                });
            })
        );
    } 
    catch (error) {
        console.log('error', error);
        removeUser(setUser, setUserTokens)
        errorResponse(error, addAlert, alertMessages.loginError);
    }
}